export default __webpack_public_path__ + "static/media/ask.928d41bf.svg";